export const setImportId = (id) => ({
    type: 'SET_ID',
    payload: { id: id },
})

export default 'a'
